import { render, staticRenderFns } from "./registration-form.vue?vue&type=template&id=2e13916c&"
import script from "./registration-form.vue?vue&type=script&lang=js&"
export * from "./registration-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./Features/Event/Components/registration-form.vue
// module id = ./Features/Event/Components/registration-form.vue
// module chunks = event.index